import { cn } from '@restworld/utils-common';

export const Pin = ({
  label,
  isActive,
  subLabel,
  isApproximate,
  isRestaurantMarker,
}: {
  label: string;
  isActive?: boolean;
  subLabel?: string;
  isApproximate?: boolean;
  isRestaurantMarker?: boolean;
}) => {
  return (
    <PinLabelWrapper
      isRestaurantsExplorer={isRestaurantMarker}
      hasPrefixIcon={isRestaurantMarker}
      isActive={isActive}
      isApproximate={isApproximate}
    >
      <PinLabel>{label}</PinLabel>
      {!isRestaurantMarker && <PinSubLabel>{subLabel}</PinSubLabel>}
    </PinLabelWrapper>
  );
};
const PinLabelWrapper = ({
  isActive,
  hasPrefixIcon,
  isRestaurantsExplorer,
  isApproximate,
  className,
  ...props
}: {
  isActive?: boolean;
  hasPrefixIcon?: boolean;
  isRestaurantsExplorer?: boolean;
  isApproximate?: boolean;
} & React.HTMLAttributes<HTMLElement>) => (
  <div
    className={cn(
      'relative z-[10] w-full max-w-[18rem] bg-neutral-10 border-0 shadow-lg rounded-[8px] text-center p-1 cursor-pointer transition-all duration-200 ease-in-out hover:bg-neutral-30',
      isActive
        ? isRestaurantsExplorer
          ? 'bg-neutral-700 text-neutral-10 hover:bg-neutral-700'
          : 'bg-purple-50 text-purple-700'
        : 'text-neutral-700',
      hasPrefixIcon && 'flex flex-row items-center justify-center gap-1',
      isRestaurantsExplorer && 'rounded-full z-[9] p-2',
      // Arrow under the pin
      "after:content-[''] after:absolute after:-bottom-5 after:left-1/2 after:-ml-2.5 after:border-[10px] after:border-solid",
      isActive
        ? isRestaurantsExplorer
          ? 'after:border-neutral-700 after:border-b-transparent after:border-r-transparent after:border-l-transparent'
          : 'after:border-purple-50 after:border-b-transparent after:border-r-transparent after:border-l-transparent'
        : 'after:border-neutral-10 after:border-b-transparent after:border-r-transparent after:border-l-transparent',
      isRestaurantsExplorer && isActive
        ? 'hover:after:border-neutral-700 hover:after:border-b-transparent hover:after:border-r-transparent hover:after:border-l-transparent'
        : 'hover:after:border-neutral-30 hover:after:border-b-transparent hover:after:border-r-transparent hover:after:border-l-transparent',
      isApproximate && 'after:hidden',
      className
    )}
    {...props}
  />
);
const PinLabel = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('text-sm font-semibold leading-5.25 max-w-full truncate', className)} {...props} />
);
const PinSubLabel = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div
    className={cn(
      'text-sm font-normal leading-4.5 rounded-[4px] py-[2px] px-[4px] bg-purple-500 text-neutral-10',
      className
    )}
    {...props}
  />
);
